<template>
<span>
  <span :class="['certify']" v-if="ok==1">
    <span class="trigle trigleok"></span><span class="cfgstatus ok" >已认证</span>
  </span>
  <span :class="['certify']" v-else-if="ok==0">
    <span class="trigle trigleerr"></span><span class="cfgstatus err" >未认证</span>

  </span>
  <span :class="['certify']" v-else-if="ok==2">
    <span class="trigle trigleerr"></span><span class="cfgstatus err" >个人转企业认证中</span>

  </span>
  <span :class="['certify']" v-else-if="ok==3">
    <span class="trigle trigleerr"></span><span class="cfgstatus err" >企业认证中 </span>

  </span>
<span :class="['certify']" v-else-if="ok==4">
    <span class="trigle trigleerr"></span><span class="cfgstatus err" >已注销</span>
  </span>
</span>
</template>
<script>
export default {
  name:"Certify",
 props:['ok']

}
</script>
<style lang="less" scoped>
.certify{
    display: inline-block;
    line-height: 20px;
    height: 20px;
    padding: 0px 5px;
    border-radius: 0 5px 5px 0;
    color:white;
    font-size: 14px;
}
.trigle{
  display: inline-block;
  line-height: 20px;
  position: relative;
  top: 5px;
  height: 20px;
  width: 0;
  height: 0;
  border: 10px solid transparent;
}
.trigleok{

  border-right-color: rgb(64,151,10);;
}
.trigleerr{
  border-right-color: rgb(255,98,43);
}
.cfgstatus{
  display: inline-block;
  line-height: 20px;
  height: 20px;
  padding:0 5px;
  border-radius: 0 3px 3px 0;
}
.ok{
  background-color: rgb(64,151,10);
}
.err{
  background-color: rgb(255,98,43);
}
</style>



// WEBPACK FOOTER //
// src/components/common/Certify.vue